export default "__VITE_ASSET__c6ff4439__"